import React, {useEffect, useState} from 'react';
import api from "../../api";
import {ToastContainer} from "react-toastify";
import moment from 'moment-jalaali';
import {e2p, formatNumber} from "../../utils/utils";

function Transaction() {
    const [transactions, setTransactions] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    
    useEffect(() => {
        function fetchTransactions() {
            setIsLoading(true);
            api.get('/wallet/transactions')
                .then(response => {
                    const transactions = response.data.data.filter(transaction => transaction.status !== 'failed');
                    setTransactions(transactions);
                })
                .catch(error => {
                    console.error('Error fetching transactions: ', error);
                })
                .finally(() => {
                    setIsLoading(false);
                });
        }
        
        fetchTransactions();
    }, []);
    
    return (
        <div className="content-wrapper">
            <div className="container-xxl flex-grow-1 container-p-y">
                <ToastContainer
                    position="top-center"
                    autoClose={1000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                />
                <div className="row justify-content-center">
                    <div className="col-12">
                        <div className="card border-3 rounded-4 border-dark mb-4">
                            <div className="card-header bg-dark text-center">
                            
                            </div>
                            <div className="card-body">
                                <div className='table-responsive'>
                                    <table className="table table-hover table-bordered table-rounded">
                                        <thead>
                                        <tr className="text-center shadow pb-4"
                                            style={{backgroundColor: 'var(--header-color)'}}>
                                            <th>مبلغ</th>
                                            <th>توضیحات</th>
                                            <th>وضعیت تراکنش</th>
                                            <th>تاریخ</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            transactions.map((transaction, index) => (
                                                <tr
                                                    key={index}
                                                    className={`${transaction.type === 'charge' ? (
                                                        transaction.status === 'pending' ? 'table-warning' : 'table-success'
                                                    ) : 'table-danger'}`}
                                                >
                                                    <td className="text-center">{e2p(formatNumber(transaction.amount))} ریال</td>
                                                    <td className="text-center">{transaction.description}</td>
                                                    <td className="text-center">
                                                        {transaction.type === 'charge' ? (
                                                            <p className="m-0 text-center">
                                                                {transaction.status === 'pending'
                                                                    ? 'در انتظار پرداخت'
                                                                    : transaction.status === 'completed'
                                                                        ? 'پرداخت شده' : ''}
                                                            </p>
                                                        ) : (
                                                            <p className="m-0 text-center">کسر شده</p>
                                                        )}
                                                    
                                                    </td>
                                                    <td className="text-center">
                                                        {e2p(
                                                            moment(transaction.created_at)
                                                                .locale('fa')
                                                                .format('jYYYY/jMM/jDD HH:mm')
                                                        ).replace(' - ', ' ')}
                                                    </td>
                                                </tr>
                                            ))
                                        }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Transaction;
